/* Hello Couleur — estimation dynamique de date de livraison.
   Lit window.HC_SHIPPING (cf. shipping.js) pour le délai de chaque mode.
   Cible deux contextes :
     1. Fiche produit : insère une <p> sous le <h3>Informations livraison</h3>
        avec la fourchette de réception pour Colissimo (mode rapide « par défaut »).
     2. Panier : remplit #cart-delivery-estimate pour le mode le moins cher
        du poids courant. Le cart appelle window.HC_DELIVERY.refreshCart()
        après chaque update. */
(function () {
  function fmtCutoff() {
    if (!window.HC_SHIPPING) return '';
    var h = window.HC_SHIPPING.CUTOFF_HOUR;
    return (h < 10 ? '0' + h : h) + 'h';
  }
  function describe(modeKey, now) {
    if (!window.HC_SHIPPING || !window.HC_SHIPPING.estimateDelivery) return '';
    var win = window.HC_SHIPPING.estimateDelivery(modeKey, now);
    if (!win) return '';
    return window.HC_SHIPPING.formatDeliveryWindow(win);
  }

  // Point final : pas de double point quand la date finit par un mois abrégé (« 8 oct. »).
  function endDot(s) { return /\.$/.test(s) ? '' : '.'; }

  // 1. Fiche produit. Depuis le 2026-09-30 : case [data-delivery-estimate] dans le volet « Livraison & retours ».
  //    Ancien repère conservé en secours : insertion avant le <h3>Informations livraison</h3>.
  function hydrateProductPage() {
    var slot = document.querySelector('[data-delivery-estimate]');
    if (slot) {
      if (slot.getAttribute('data-filled') || !window.HC_SHIPPING) return;
      var n = new Date();
      var f = window.HC_SHIPPING.estimateDelivery('colissimo', n);
      var sl = window.HC_SHIPPING.estimateDelivery('timbre', n);
      if (!f) return;
      var r = window.HC_SHIPPING.formatDeliveryWindow({ from: f.from, to: (sl && sl.to > f.from) ? sl.to : f.to });
      slot.innerHTML = 'Commandez avant <strong>' + fmtCutoff() + '</strong> (jours ouvrés) : réception estimée <strong>' + r + '</strong>' + endDot(r)
        + '<span style="display:block;margin-top:6px;font-size:0.8125rem;color:var(--c-crayon);font-style:italic;">Le délai sera ajusté selon le mode de livraison choisi au paiement.</span>';
      slot.setAttribute('data-filled', '1');
      slot.hidden = false;
      return;
    }
    var headings = document.querySelectorAll('h3');
    var target = null;
    for (var i = 0; i < headings.length; i++) {
      if (/^\s*Informations livraison\s*$/i.test(headings[i].textContent)) {
        target = headings[i];
        break;
      }
    }
    if (!target) return;
    // Évite la double injection (idempotent en cas de hot-reload).
    if (target.previousElementSibling && target.previousElementSibling.classList.contains('product__delivery-estimate')) return;
    if (!window.HC_SHIPPING) return;
    var now = new Date();
    var fast = window.HC_SHIPPING.estimateDelivery('colissimo', now); // borne basse = meilleur délai possible
    var slow = window.HC_SHIPPING.estimateDelivery('timbre', now);    // borne haute = mode le plus lent
    if (!fast) return;
    var to = (slow && slow.to > fast.from) ? slow.to : fast.to;
    var range = window.HC_SHIPPING.formatDeliveryWindow({ from: fast.from, to: to });
    var p = document.createElement('p');
    p.className = 'product__delivery-estimate';
    p.innerHTML =
      'Commandez avant <strong>' + fmtCutoff() + '</strong> (jours ouvrés) — réception estimée <strong>' + range + '</strong>' + endDot(range)
      + '<span style="display:block;margin-top:6px;font-size:0.8125rem;color:var(--c-crayon);font-style:italic;">Le délai sera ajusté selon le mode de livraison choisi au paiement.</span>';
    target.parentNode.insertBefore(p, target);
  }

  // 2. Panier : on remplit #cart-delivery-estimate (placeholder ajouté dans 05_cart).
  // L'appelant fournit le mode (clé) sélectionné par cheapest() côté cart.
  function renderCartEstimate(modeKey) {
    var el = document.getElementById('cart-delivery-estimate');
    if (!el) return;
    if (!modeKey || !window.HC_SHIPPING) { el.textContent = ''; return; }
    var now = new Date();
    var fast = window.HC_SHIPPING.estimateDelivery('colissimo', now); // borne basse = meilleur délai possible
    var slow = window.HC_SHIPPING.estimateDelivery(modeKey, now);     // borne haute = mode par défaut (le moins cher)
    if (!slow) { el.textContent = ''; return; }
    var from = (fast && fast.from < slow.from) ? fast.from : slow.from;
    var to = slow.to;
    if (to < from) to = from;
    var range = window.HC_SHIPPING.formatDeliveryWindow({ from: from, to: to });
    el.innerHTML = 'Recevez votre commande <strong>' + range + '</strong>' + endDot(range)
      + '<span style="display:block;margin-top:6px;font-size:0.8125rem;color:var(--c-crayon);font-style:italic;">Le délai sera ajusté selon le mode de livraison choisi au paiement.</span>';
  }

  window.HC_DELIVERY = {
    refreshCart: renderCartEstimate,
    estimateText: describe
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateProductPage);
  } else {
    hydrateProductPage();
  }
})();
